import React from "react";

const PageBanner = ({ title, breadcrumb, backgroundImage }) => {
  return (
    <div className="relative h-64 md:h-80 flex items-center justify-center z-5">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      {/* Text */}
      <div className="relative z-10 text-center text-white px-4">
        <h1 className="text-4xl font-bold mb-2">{title}</h1>
        <p className="text-sm text-secondary">{breadcrumb}</p>
      </div>
    </div>
  );
};

export default PageBanner;
